import React from "react";

import { Dialog } from "../../components/index";
import homeStore from "../../stores/homeStore";

import "./dialog.scss";

interface Props {
  visible: boolean;
}

const SuccessDialog: React.FC<Props> = (props: Props) => {
  const { setAddCase, setSuccessShow } = homeStore();

  const onCancel = () => {
    setSuccessShow(false);
  };

  return (
    <Dialog
      {...props}
      style={{ padding: "30px 14px 20px" }}
      onCancel={onCancel}
    >
      <div className="success-dialog">
        <img src={window._config.assets.success} alt="icon" />
        <p>提交成功</p>
        <div className="success-dialog__content">
          文章信息自动生成中，约 1 分钟后刷新可见
        </div>
        <div
          className="success-dialog__btn"
          onClick={() => {
            onCancel();
            setAddCase(true);
          }}
        >
          继续提交
        </div>
      </div>
    </Dialog>
  );
};

export default SuccessDialog;
